module.exports = __webpack_public_path__ + "img/lg_ring_y_skip_null_1@2x.88b30d2c.png";